app.ExpoPrinterList = app.AbstractCollection.extend({
  model: app.ExpoPrinter,

  url() {
    return app.apiPathForLocation('/expo-status');
  },
});
